import react, { useContext, useEffect, useReducer, useMemo } from 'react'
import ColorButton from '../../Buttons/ColorButton'
import Table from '../../Table'
import { lockedReducer } from '../../Utils/reducers'
import { externalComponent } from '../../AppRoutes'
import { api } from '../../../services/api'
import toast from 'react-hot-toast'
import { ThemeProvider, useTheme } from '@mui/material/styles';
import { customTheme } from '../../theme/textfieldTheme'
import { Alert, TextField, Box } from '@mui/material'
import { PercentFormatInputFive } from '../../Utils/PercentInputDefault'

let timeout = 0
const timeoutTime = 50

const submit = async (state, setState, setLoader) => {
    setLoader(true)
    const res = await api.post('condicao_pagamento/', state.rows)
    if (res.status === 200){
        toast.success('Dados salvos com sucesso')
    } else {
        toast.error('Erro: Dados não foram salvos')
    }
    setLoader(false)
}

const changeData = (props, rows, newvalue, setState, extra = {}) => {
    clearTimeout(timeout)
    const row = rows.find(row => row.id === props.row.id)
    const value = { id: props.row.id, [props.field]: newvalue, ...extra }
    Object.assign(row, value)
    props.api.updateRows([value])
    timeout = setTimeout(() => {
        setState({ products_rows: [...rows] })
    }, timeoutTime)
}

const getcolumns = (rows, setState) => {
    const columns = []
    columns.push({ field: 'label', headerName: 'Nome', flex: 1 })
    columns.push({ field: 'IntervaloDias', headerName: 'Intervalo Dias', flex: 1 })
    columns.push({
        field: 'val_desc', headerName: 'Valor Desconto', width: 300, renderCell: (props) => (
            <TextField
                value={props.value / 100}
                onChange={({ target }) => { changeData(props, rows, Number(target.value * 100), setState) }}
                InputProps={{
                    inputComponent: PercentFormatInputFive,
                    sx: { fontSize: '13px' }
                }}
            />
        )
    })
    return columns
}

const initialize = async (setState, setLoader) => {
    setLoader(true)
    const res = await api.get('condicao_pagamento/')
    if (res.status === 200)
        setState({ rows: res.data, ready: true })
    else
        toast.error('Falha ao recuperar as condições de pagamento')
    setLoader(false)
}

const CondPag = () => {

    const { setLoader } = useContext(externalComponent)

    const [state, setState] = useReducer(lockedReducer, {
        loading: false,
        rows: [],
        ready: false
    })

    useEffect(() => {
        initialize(setState, setLoader)
    }, [])

    const outerTheme = useTheme()

    const setColumns = useMemo(() => getcolumns(state.rows, setState), [state.rows])

    return (
        <>
            <ColorButton onClick={() => submit(state, setState, setLoader)} sx={{ maxWidth: '10rem' }}>Salvar</ColorButton>
            <Alert severity='warning'>Valores negativos de desconto serão tratados como acréscimo</Alert>
                {state.ready &&
                    <Table
                        disableRowSelectionOnClick
                        paginationMode='client'
                        className='contabil-grid'
                        rows={state.rows}
                        columns={setColumns}
                        pagination={false}
                        toolbar
                        slots={{
                            filterComponent: true,
                            columnComponent: true
                        }}
                        density='compact'
                        rowHeight={30}
                    />}
            {/* </ThemeProvider> */}
        </>
    )
}

export default CondPag